import { render, staticRenderFns } from "./ClientSwitcher.vue?vue&type=template&id=0f0b1a8e&scoped=true"
import script from "./ClientSwitcher.vue?vue&type=script&lang=js"
export * from "./ClientSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ClientSwitcher.vue?vue&type=style&index=0&id=0f0b1a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b1a8e",
  null
  
)

export default component.exports